import { render } from "./Manifesto.vue?vue&type=template&id=7e11fc56&lang=true"
import script from "./Manifesto.vue?vue&type=script&lang=js"
export * from "./Manifesto.vue?vue&type=script&lang=js"

import "./Manifesto.vue?vue&type=style&index=0&id=7e11fc56&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__